<template>
  <div class="postedProduct">
    <van-pull-refresh v-model="refresh" @refresh="onRefresh">
      <div class="postedBox" :style="$commonMethod.customAppHeader(1, 100)">
        <van-row type="flex" align="center" class="search-top-row">
          <van-col class="colItem" @click="changeType(0)">
            <section :class="['itemTop', active === 0 ? 'itemTopAction' : '']">
              <p class="itemTopName">{{ $t.meta.followPage }}</p>
            </section>
            <div :class="['itemBorder', active === 0 ? 'itemBorderAction' : '']"></div>
          </van-col>
          <van-col class="colItem" @click="changeType(1)">
            <section :class="['itemTop', active === 1 ? 'itemTopAction' : '']">
              <p class="itemTopName">{{ $t.meta.sharedPage }}</p>
            </section>
            <div :class="['itemBorder', active === 1 ? 'itemBorderAction' : '']"></div>
          </van-col>
        </van-row>
      </div>

      <van-list v-model="loading" :finished="finished" :finished-text="$t.noMoreData" @load="onLoad">
        <div class="list">
          <share-list :listProduct="listProduct"></share-list>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import Vue from "vue";
import { Row, Col, List, PullRefresh } from "vant";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";

Vue.use(Row).use(List).use(Col).use(PullRefresh);

import ShareList from "./components/ShareList";
export default {
  name: "postedProduct",
  components: {
    ShareList,
  },
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      active: 1,
      listProduct: [], //产品
      type: 1,
      pageIndex: 1, //页码,
      refresh: false,
      loading: true,
      finished: false,
    };
  },
  mounted() {
    //首次加载数据
    this.getShopProductsByPage();
  },
  methods: {
    changeType(index) {
      if (index == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: false,
          path: "focus/follow",
          name: "Follow",
          query: [],
        });
      }
    },
    onRefresh() {
      this.refresh = true;
      this.getShopProductsByPage(true)
        .then(() => {
          this.refresh = false;
        })
        .catch(() => {
          this.refresh = false;
        });
    },
    // 首次加载数据
    getShopProductsByPage(hideLoading = false) {
      return new Promise((resolve, reject) => {
        if (!hideLoading) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showLoading);
        }
        let param = {};
        if (this.type !== 0 && this.type !== 1) {
          param = {
            PageIndex: 1,
          };
        } else {
          param = {
            PageIndex: 1,
            ScreenValues: this.type,
          };
        }
        this.$api.follow
          .loadShareProductByPage(param)
          .then((res) => {
            const data = res.data;
            this.listProduct = data;
            if (data === "" || data === null || data.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            this.loading = false;
            if (!hideLoading) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            }
            resolve();
          })
          .catch((error) => {
            this.loading = false;
            if (!hideLoading) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            }
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
              status: error.status,
            });
            reject();
          });
      });
    },
    //加载更多
    onLoad() {
      let param = {};
      this.finished = false;
      if (this.type !== 0 && this.type !== 1) {
        param = {
          PageIndex: this.pageIndex + 1,
        };
      } else {
        param = {
          PageIndex: this.pageIndex + 1,
          ScreenValues: this.type,
        };
      }
      this.$api.follow
        .loadShareProductByPage(param)
        .then((res) => {
          const data = res.data;
          if (data === "" || data === null || data.length === 0) {
            this.loading = false;
            this.finished = true;
          } else {
            this.listProduct = this.listProduct.concat(data);
            this.pageIndex = this.pageIndex + 1;
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

@mixin spanNowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@mixin puiblicFlex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}

.postedProduct {
  width: 100%;
  font-size: 26px;

  .van-pull-refresh {
    overflow: unset;
  }

  .list {
    width: 100%;
  }

  .postedBox {
    z-index: 999;
    width: 100%;
    background: linear-gradient(left, #25b9ff, #0090e6);

    .search-top-row {
      width: 100%;
      padding-top: 14px;
      text-align: center;
      background: linear-gradient(left, #25b9ff, #0090e6);

      .colItem {
        width: 50%;
        text-align: center;
        color: #fff;

        .itemTop {
          @include puiblicFlex;
          text-align: center;
          justify-content: center;
          -webkit-justify-content: center;

          .itemTopName {
            font-size: 16px;

            margin: 0;
            padding: 0;
          }

          .itemTopNum {
            margin: 0;
            padding: 0;
          }
        }

        .itemBorder {
          height: 4px;
          width: 30px;
          // background-color: #0090e6;
          margin: 0 auto;
          border-radius: 16px;
          margin-top: 10px;
          opacity: 0;
        }

        .itemBorderAction {
          background-color: #fff;
          opacity: 1;
        }
      }
    }
  }
}
</style>
